import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class PlanningDetailSnapshotSearchParams extends SearchParamsBase {
  initialize() {
    this.PlanningDetailId = '';
    this.PricingId = '';
    this.Status = '';
    this.FromDate = '';
    this.ToDate = '';
  }

  ClearAll() {
    this.initialize();
  }

  static fieldsInSearchBox = [
    { fieldName: 'PlanningDetailId', label: 'Planning Detail Id', className: 'col-2', type: InputTypesEnum.Number },
    { fieldName: 'PricingId', label: 'Pricing Id', className: 'col-2', type: InputTypesEnum.Number },
    { fieldName: 'Status', label: 'Status', className: 'col-2', type: InputTypesEnum.Text },
    { fieldName: 'FromDate', label: 'Snapshot From', className: 'col-3', type: InputTypesEnum.Date },
    { fieldName: 'ToDate', label: 'Snapshot To', className: 'col-3', type: InputTypesEnum.Date },
  ];

  static indexOfFirstFieldInAdvanced = 5;
  static title = 'Search for Snapshot';
  static iconName = 'fa-solid fa-search';
  static saveType = 'PlanningDetailSnapshotSearchParams';

  static isThereAnySearchParameter(searchItem) {
    const defaultSearchItem = new PlanningDetailSnapshotSearchParams();
    for (const key in searchItem) {
      if (searchItem[key] !== defaultSearchItem[key]) return true;
    }
    return false;
  }
}
